import { render, staticRenderFns } from "./QaExpireUser.vue?vue&type=template&id=799e7e78&scoped=true"
import script from "./QaExpireUser.vue?vue&type=script&lang=ts"
export * from "./QaExpireUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e7e78",
  null
  
)

export default component.exports